// extracted by mini-css-extract-plugin
module.exports = {"headline":"Heading_headline__nP5pz","subtitle":"Heading_subtitle__uG_Nm","subheadline":"Heading_subheadline__MH6QW","spacing-4":"Heading_spacing-4___JBqk"};